import { Filter } from '../types'
import { BaseFilter } from './base'
import { ComboboxFilter } from './combobox'
import { DateFilter } from './date'
import { DateRangeFilter } from './date-range'
import { SelectFilter } from './select'

export class FilterFactory {
  static getFilter(filter: Filter): BaseFilter {
    switch (filter.type) {
      case 'select':
        return new SelectFilter()
      case 'combobox':
        return new ComboboxFilter()
      case 'date':
        return new DateFilter()
      case 'date-range':
        return new DateRangeFilter()
      default:
        throw new Error(`Unknown filter type: ${(filter as { type: string }).type}`)
    }
  }
}
